import mixpanel, { type Config } from "mixpanel-browser";

let initialized = false;

export function initMixpanel(token: string, config?: Partial<Config>): void {
  if (!token || initialized) return;

  mixpanel.init(token, {
    track_pageview: false,
    persistence: "localStorage",
    batch_requests: false,
    ...config,
  });

  initialized = true;
}

export function identifyUser(
  userId: string,
  userProps?: Record<string, unknown>,
): void {
  if (!initialized) return;

  mixpanel.identify(userId);

  if (userProps && Object.keys(userProps).length > 0) {
    mixpanel.people.set(userProps);
  }
}

export function setSuperProperties(props: Record<string, unknown>): void {
  if (!initialized) return;
  mixpanel.register(props);
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  mixpanel.track(event, props);
}

export function resetAnalytics(): void {
  if (!initialized) return;
  mixpanel.reset();
}
